module.exports = "img/flags/CG.2308cc7.png";